<div class="parent">
	<ion-row
		(click)="addItem(); $event.stopPropagation()"
		[class.selectedRed]="selected > 0 && customRemove"
		[class.selected]="selected > 0 && !customRemove"
		class="item-selectable-article"
	>
		<div class="wrapper-item">
			<div class="selected-block">
				@if ((article.info | langObservable | async).length > 0) {
					<ion-icon class="info" src="../../../assets/topgolf/info.svg"></ion-icon>
				}

				<div class="added-item">
					<div class="selected-circle">
						<ion-icon [class.selected]="selected > 0" src="../../../assets/topgolf/selected.svg"></ion-icon>
					</div>
				</div>
			</div>
			<p class="name">
				{{ (article.name | langObservable | async).replace('---', '').replace('+++', '') }}
			</p>
			<ion-row>
				<ion-col lass="ion-no-padding">
					@if (article.assets.medium) {
						<ion-img
							(ionError)="onError($event, article.assets.original)"
							[src]="article.assets.medium"
							class="item-selectable-article-image ion-no-margin ion-no-padding"
						></ion-img>
					}

					@if (!article.assets.medium) {
						<ion-icon
							class="item-selectable-article-image default-img ion-no-margin ion-no-padding"
							src="../../../assets/topgolf/header_logo.svg"
						></ion-icon>
					}
				</ion-col>
			</ion-row>
			<div class="wrapp">
				@if (group && group.hasMultiple && !isEmptyArticle && !customAdd && !customRemove) {
					<div class="quantity-selector">
						<ion-icon
							(click)="removeEmit(); $event.stopPropagation()"
							[disabled]="selected === 0"
							class="quantity-btn"
							src="../../../assets/icon/minus.svg"
						></ion-icon>
						<p class="quantity">{{ selected > 0 ? selected : '' }}</p>
						<ion-icon (click)="add.emit()" class="quantity-btn" src="../../../assets/icon/plus.svg"></ion-icon>
					</div>
				}
			</div>
		</div>

		<div class="footer-block">
			<div class="left-section">
				@if (price > 0) {
					<p class="option-price">{{ numberToCurrency(price, currency) }}</p>
				}
				@if (article?.kcal) {
					<p class="option-item">{{ article?.kcal }} {{ 'common.cal' | translate }}</p>
				}
			</div>
		</div>
	</ion-row>
</div>
